// Import model
import { MultiSelectField } from '../models/MultiSelectField';

// Import base class serializer
import { FieldSerializer } from './FieldSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for MultiSelectField - handles JSON serialization and deserialization with type validation
 */
export class MultiSelectFieldSerializer {
  /**
   * Deserializes a JSON string into a MultiSelectField instance
   */
  static deserialize(json: string): MultiSelectField {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a MultiSelectField instance
   */
  static fromObject(obj: any): MultiSelectField {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to MultiSelectField');
    }


    const instance: MultiSelectField = {
      t: obj['_t'] as string,
      description: obj['Description'] as string | undefined,
      apiName: obj['ApiName'] as string | undefined,
      defaultValue: obj['DefaultValue'] as any | undefined,
      isRequired: obj['IsRequired'] as boolean | undefined,
      options: obj['Options'] ? FieldOptionsSerializer.fromObject(obj['Options']) : undefined as any,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      _89C43355: obj['_89c43355'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of MultiSelectField instances
   */
  static deserializeArray(json: string): MultiSelectField[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a MultiSelectField instance to a JSON string
   */
  static serialize(instance: MultiSelectField): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a MultiSelectField instance to a plain object
   */
  static toObject(instance: MultiSelectField): any {
    return {
      '_t': instance.t,
      'Description': instance.description,
      'ApiName': instance.apiName,
      'DefaultValue': instance.defaultValue,
      'IsRequired': instance.isRequired,
      'Options': instance.options ? FieldOptionsSerializer.toObject(instance.options) : undefined,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      '_89c43355': instance._89C43355,
    };
  }

  /**
   * Serializes an array of MultiSelectField instances to a JSON string
   */
  static serializeArray(instances: MultiSelectField[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
